export const ADD_ARTICLE = "ADD_ARTICLE";
export const CHANGE_FOOTER = "CHANGE_FOOTER";